<template>
  <div>
    <div class="transparent-cover" :class="{ 'd-none': !isActive }" @click="isActive = false"></div>
    <div class="nav-elastic-search" :class="{ 'active-elastic-search': isActive }">
      <form onsubmit="event.preventDefault();" autocomplete="off" class="">
        <div class="search-top">
          <div class="toggle-icon"><span class="icon-arrow-down-sort pull-left f-s-10" :class="{ 'arrow-top': isActive }"></span></div>
          <input type="text" name="text" @focus="isActive = true" v-model="title" placeholder="جستجوی محصول " class="text-search" /><span class="icon-search pointer"></span>
          <span class="icon-round-search pointer"></span>
          <div class="advance-body" :class="{ 'd-none': !isActive }">
            <div class="boo w-Nw">
              <span class="ZG"><label for="title"> عنوان محصول</label></span
              ><span class="w-Pv"><input type="search" id="title" class="mdc-text-field__input" placeholder=" بخشی از عنوان محصول" v-model="title" inputvalue="" value="" /></span>
            </div>
            <div class="boo w-Nw">
              <span class="ZG"><label for="productId">شناسه‌ی محصول </label></span
              ><span class="w-Pv ltr"><input id="productId" type="search" class="mdc-text-field__input" placeholder="۲۵۳۴" v-model="id" inputvalue="" value="" /></span>
            </div>
            <div class="action-button">
              <button class="blue" @click="submit">جست‌وجو</button>
              <button class="remove-search" @click="clear">پاک کردن فرم</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: "NavSearch",
  data() {
    return {
      isActive: false,
      id: null,
      title: null
    }
  },
  props: [
      'search'
  ],
  methods: {
      submit() {
          this.search.title = this.title;
          this.search.id = this.id
      },
      clear() {
          this.id = null
          this.title = null
          this.search.title = ''
          this.search.id = ''
      }
  }
}
</script>